module.exports = __webpack_public_path__ + "static/img/default.861497ba.png";